import type { IColumn } from 'types'

import { setValue } from 'helpers/common'
import { routes } from 'helpers/routes'
import { Breadcrumb } from 'recoils/atoms'

export const HEADERS: IColumn[] = [
  {
    key: 'no',
    label: 'common:header.no.label',
    sortable: false,
    width: 6,
  },
  {
    key: 'thumbnailImage',
    label: 'product:header.image.label',
    sortable: false,
    width: 10,
  },
  {
    key: 'name',
    label: 'product:header.name.label',
    sortable: true,
    width: 40,
  },
  {
    key: 'serialNumber',
    label: 'product:header.id.label',
    sortable: true,
    width: 14,
  },
  {
    key: 'dateOfPurchase',
    label: 'product:header.dateOfPurchase.label',
    sortable: true,
    width: 11,
  },
  {
    key: 'endWarranty',
    label: 'product:header.endDateWarranty.label',
    sortable: true,
    width: 11,
  },
  {
    key: 'isActive',
    label: 'common:header.status.label',
    sortable: true,
    width: 8,
  },
]

export const HEADERS_LOADING: IColumn[] = [
  {
    key: 'no',
    label: '',
    sortable: false,
    width: 5,
  },
  {
    key: 'thumbnailImage',
    label: '',
    sortable: false,
    width: 10,
  },
  {
    key: 'name',
    label: '',
    sortable: true,
    width: 40,
  },
  {
    key: 'serialNumber',
    label: '',
    sortable: true,
    width: 15,
  },
  {
    key: 'dateOfPurchase',
    label: '',
    sortable: true,
    width: 30,
  },
]

export const SKELETON_BRANCH_INFO = [
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
  {
    widthTitle: '56px',
    widthDescription: '228px',
  },
  {
    widthTitle: '56px',
    widthDescription: '228px',
  },
]

export const SKELETON_PRODUCT_INFO = [
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
  {
    widthTitle: '56px',
    widthDescription: '228px',
  },
  {
    widthTitle: '56px',
    widthDescription: '228px',
  },
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
]

export const SKELETON_WARRANTY = [
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
  {
    widthTitle: '56px',
    widthDescription: '228px',
  },
  {
    widthTitle: '56px',
    widthDescription: '228px',
  },
  {
    widthTitle: '74px',
    widthDescription: '121px',
  },
]

export const getDetailByWarrantyPeriod = (
  warrantyPeriod?: string,
  maintenancePeriod?: string,
  startDate?: string,
  endDate?: string,
  qrCode?: string | null,
): { title: string; description: string }[] => [
  {
    title: 'product:warranty.time.label',
    description: setValue(warrantyPeriod),
  },
  {
    title: 'product:warranty.maintenancePeriod.label',
    description: setValue(maintenancePeriod),
  },
  {
    title: 'product:warranty.startDate.label',
    description: setValue(startDate),
  },
  {
    title: 'product:warranty.endDate.label',
    description: setValue(endDate),
  },
  {
    title: 'product:warranty.qrcode.label',
    description: setValue(qrCode),
  },
]

export const getDetailByWarrantyLifeTime = (
  maintenancePeriod?: string,
  qrCode?: string | null,
): { title: string; description: string }[] => [
  {
    title: 'product:warranty.maintenancePeriod.label',
    description: setValue(maintenancePeriod),
  },
  {
    title: 'product:warranty.qrcode.label',
    description: setValue(qrCode),
  },
]

export const renderBreadcrumbsList = (id: string): Breadcrumb[] => [
  { key: routes.branch.path, label: 'layout:branchManagement.breadcrumb' },
  {
    key: `${routes.branch.path}/${id}/product`,
    label: 'layout:productManagement.breadcrumb',
  },
]

export const renderBreadcrumbsCreate = (id: string): Breadcrumb[] => [
  { key: routes.branch.path, label: 'layout:branchManagement.breadcrumb' },
  {
    key: `${routes.branch.path}/${id}/product`,
    label: 'layout:productManagement.breadcrumb',
  },
  {
    key: `${routes.branch.path}/${id}/product/new`,
    label: 'layout:createProduct.breadcrumb',
  },
]

export const renderBreadcrumbsEdit = (
  branchId: string,
  productId: string,
): Breadcrumb[] => [
  { key: routes.branch.path, label: 'layout:branchManagement.breadcrumb' },
  {
    key: `${routes.branch.path}/${branchId}/product`,
    label: 'layout:productManagement.breadcrumb',
  },
  {
    key: `${routes.branch.path}/${branchId}/product/${productId}`,
    label: 'layout:editProduct.breadcrumb',
  },
]

export const renderBreadcrumbsDetail = (
  branchId: string,
  productId: string,
): Breadcrumb[] => [
  {
    key: routes.branch.path,
    label: 'layout:branchManagement.breadcrumb',
  },
  {
    key: `${routes.branch.path}/${branchId}/product`,
    label: 'layout:product.breadcrumb',
  },
  {
    key: `${routes.branch.path}/${branchId}/product/${productId}/detail`,
    label: 'layout:detailProduct.breadcrumb',
  },
]

export const PRODUCTTEMPLATE = 'productImportTemplate'

export const QR_CODE_LENGTH = 15
